// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2hgHZ","title":"FrontImage_title__3-mL_"};